import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React,{Component} from 'react';
import Modal from 'react-modal';
import Alert from 'react-s-alert';
import firebase from 'firebase';


const database=firebase.database();


const customStyles = {
  content : {
    top                   : '60%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};


class ModalTarifas extends Component{
	
	constructor(props){
		super(props)
		
		this.state={
			isActive:false,
			isActiveEmpresas:false,
			empresas:[],
			monto:'',
			distancia:'',
			nombreTarifa:'',
			uidEmpresa:'',
			nombreEmpresa:'',
			tipoServicio:'',
			disabled:'disabled',
			d_5km:'',
			d_10km:'',
			d_15km:'',
			d_mas15km:''
		
		}
		
		//Referencias a la base de datos
		this.empresasRef=database.ref().child('Empresa');
		this.tarifasRef=database.ref().child('Tarifas');
		
		this.toggleModal=this.toggleModal.bind(this);
		this.toggleModalEmpresas=this.toggleModalEmpresas.bind(this);
		this.renderContenido=this.renderContenido.bind(this);
		this.submitInsert=this.submitInsert.bind(this);
		this.handleChange=this.handleChange.bind(this);
		this.handleClick=this.handleClick.bind(this);
		this.handleClickEmpresa=this.handleClickEmpresa.bind(this);
	
	}
	
	componentWillMount(){
		
		this.empresasRef.on('value', this.gotData, this.errData);
	}
	
	componentDidMount(){
		
		this.empresasRef.on('value', this.gotData, this.errData);
		
	}
	
	gotData = (data) => {
		  let newEmpresa = []
		  if(data.val()!==null){
			const empresadata = data.val();
			const keys = Object.keys(empresadata);

			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
					
				newEmpresa.push({
				key:k,
				codigo_activacion:empresadata[k].codigo_activacion,
				codigo_empresa:empresadata[k].codigo_empresa,
				correo:empresadata[k].correo,
				estado:empresadata[k].estado,
				razon_social:empresadata[k].razon_social,
				representante:empresadata[k].representante,	
				telefono_empresa:empresadata[k].telefono_empresa
				});
			}
			}
		  this.setState({empresas: newEmpresa});
		}
		errData = (err) => {
	  console.log(err);
	}
	
	
	
	toggleModal(){
		
		this.setState({
			disabled:'disabled',	
			tipoServicio:'',
			uidEmpresa:'',
			nombreEmpresa:'',
			isActive:!this.state.isActive
			
		});
		
	}
	
	toggleModalEmpresas(){
		this.setState({
			
			isActiveEmpresas:!this.state.isActiveEmpresas
			
		});
		
	}
	
	
	submitInsert(event){
		
		

		// let insert=false;
		
		//Tarifas por distancias
		let cincoKilometros=this.cincoKilometros.value;
		let diezkilometros=this.diezkilometros.value;
		let quinceKilometros=this.quinceKilometros.value;
		let masveinteycinco=this.masveinteycinco.value;
		
		
		if(this.state.tipoServicio==='empresa'){
	
			
			
			database.ref().child('Tarifas').orderByChild('uid_empresa').equalTo(this.state.uidEmpresa).once("value").then(snapshot=>{
					
					if(snapshot.exists()){
					
						Alert.warning('Ya hay una tarifa registrada para esta empresa', {
							effect: 'genie',
							position: 'bottom-right',
							timeout:2000			
						});
						
					}
					else{
							
						database.ref().child('Tarifas').child(this.state.uidEmpresa).update({
				
							nombre_tarifa:this.state.nombreEmpresa,
							uid_empresa:this.state.uidEmpresa,
							d_5km:cincoKilometros,
							d_10km:diezkilometros,
							d_15km:quinceKilometros,
							d_mas15km:masveinteycinco
							
							
				
						})
						
						Alert.success('Datos guardados correctamente', {
							effect: 'genie',
							position: 'bottom-right',
							timeout:2000			
						});
						this.toggleModal();
						
					}
			});
		
			
		}
		else{
			
			
			database.ref().child('Tarifas').orderByChild('nombre_tarifa').equalTo(this.state.tipoServicio).once("value").then(snapshot=>{
					
					if(snapshot.exists()){
					
						Alert.warning('Ya hay una tarifa registrada para este servicio', {
							effect: 'genie',
							position: 'bottom-right',
							timeout:2000			
						});
						
					}
					else{
							
						this.tarifasRef.push({
				
							nombre_tarifa:this.state.tipoServicio,
							d_5km:cincoKilometros,
							d_10km:diezkilometros,
							d_15km:quinceKilometros,
							d_mas15km:masveinteycinco
			
						})
						
						Alert.success('Datos guardados correctamente', {
							effect: 'genie',
							position: 'bottom-right',
							timeout:2000			
						});
						this.toggleModal();
						
					}
			});
			
		}
	
		
		
			
		event.preventDefault();
		
	}
	
	
	//Controla el cambio del combobox o select 
	handleChange(){
		
		let opcion=this.tipoServicio.value;
		
		this.setState({
			
			tipoServicio:opcion,
			nombreEmpresa:'',
			uidEmpresa:'',
			disabled:''
		});
		
	}
	
	//Cambia el estado para abrir el modal de seleccion de empresas
	handleClick(){

		this.setState({
			isActiveEmpresas:!this.state.isActiveEmpresas
		});
		
	}
	
	handleClickEmpresa(row){
		
		
		this.setState({
			
				uidEmpresa:row.key,
				nombreEmpresa:row.codigo_empresa
		});
		
		this.toggleModalEmpresas();
		
	}
	
	//Renderiza el  contenido del modal segun el tipo de servicio que el usuario seleccione
	renderContenido(){
		
		
		if(this.state.tipoServicio==='empresa')
				{

					return(
						
						<div className="form-empresa">
							<div className="form-group">
								<label htmlFor="empresa">Empresa</label>
								<input type="text" name="empresa" readOnly="readonly" placeholder="Elige una empresa" className="form-control"
								required value={this.state.nombreEmpresa}
								onClick={this.handleClick}
								/> 
							</div>
							
							<fieldset>
								<legend>Tarifas</legend>
								<div className="form-group">
									<label htmlFor="cincoKilometros">5 km</label>
									<input type="text" name="cincoKilometros" placeholder="Monto" className="form-control"
									ref={input => {this.cincoKilometros=input;}} autoComplete="off"
									required
									/>
								</div>		
								<div className="form-group">
									<label htmlFor="diezkilometros">10 km</label>
									<input type="text" name="diezkilometros" placeholder="Monto" className="form-control"
									ref={input => {this.diezkilometros=input;}} autoComplete="off"
									required
									/>
								</div>
								<div className="form-group">
									<label htmlFor="quinceKilometros">15 km</label>
									<input type="text" name="quinceKilometros" placeholder="Monto" className="form-control"
									ref={input => {this.quinceKilometros=input;}} autoComplete="off"
									required
									/>
								</div>
								<div className="form-group">
									<label htmlFor="masveinteycinco">Mas de 15 km</label>
									<input type="text" name="masveinteycinco" placeholder="Monto" className="form-control"
									ref={input => {this.masveinteycinco=input;}} autoComplete="off"
									required
									/>
								</div>
								
							</fieldset>
							
						</div>
					
					);
							
				}
				else if(this.state.tipoServicio==='privado' || this.state.tipoServicio==='normal'){
					
					return(
						
						<div className="form-privados">
			
												<fieldset>
								<legend>Tarifas</legend>
								<div className="form-group">
									<label htmlFor="cincoKilometros">5 km</label>
									<input type="text" name="cincoKilometros" placeholder="Monto" className="form-control"
									ref={input => {this.cincoKilometros=input;}} autoComplete="off"
									required
									/>
								</div>		
								<div className="form-group">
									<label htmlFor="diezkilometros">10 km</label>
									<input type="text" name="diezkilometros" placeholder="Monto" className="form-control"
									ref={input => {this.diezkilometros=input;}} autoComplete="off"
									required
									/>
								</div>
								<div className="form-group">
									<label htmlFor="quinceKilometros">15 km</label>
									<input type="text" name="quinceKilometros" placeholder="Monto" className="form-control"
									ref={input => {this.quinceKilometros=input;}} autoComplete="off"
									required
									/>
								</div>
								<div className="form-group">
									<label htmlFor="masveinteycinco">Mas de 15 km</label>
									<input type="text" name="masveinteycinco" placeholder="Monto" className="form-control"
									ref={input => {this.masveinteycinco=input;}} autoComplete="off"
									required
									/>
								</div>
								
							</fieldset>
							
							
						</div>				
					);
				
				}
		
	}
	
	btnSeleccionar(cell,row){
		
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClickEmpresa(row)}} >Seleccionar</button>;
		
	}
	
	
	render(){
		
		return(
			<div className="modal-tarifas">
			
				<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
				
	
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles}>
					
						<h3>Agregar una nueva tarifa</h3>
						
						<hr/>
						
						<form method="POST" action="" onSubmit={this.submitInsert}>
							
							<div className="form-group">
								<label htmlFor="tipo">Selecciona el tipo de servicio</label>
								<select className="form-control"
								  ref={input =>{this.tipoServicio=input;}} onChange={this.handleChange}
								>
									<option value="privado">Privado</option>
									<option value="normal">Normal</option>
									<option value="empresa">Empresa</option>
								</select>
								
								{this.renderContenido()}
							</div>
							
							<hr/>
							
							<button type="submit" className="btn btn-primary buttons" disabled={this.state.disabled}>Guardar</button>
						</form>
							<button type="button" className="btn btn-default buttons  btnmargin" onClick={this.toggleModal}>Cerrar</button>
					
					</Modal>			
				
					<Modal isOpen={this.state.isActiveEmpresas} onRequestClose={this.toggleModalEmpresas}  style={customStyles}>
					
					
						<h3>Elige una empresa</h3>
						<hr/>
						<BootstrapTable data={ this.state.empresas }
							 ref='table'			 
							 pagination={ true }
							 search={ true }
							 hover
							 >
							 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							 <TableHeaderColumn dataField='codigo_empresa' dataSort={true}>Empresa</TableHeaderColumn>			
							 <TableHeaderColumn dataField='razon_social'>Razon Social</TableHeaderColumn>				
							 <TableHeaderColumn dataField='ver' dataAlign='center' dataFormat={ this.btnSeleccionar.bind(this) }>Seleccionar</TableHeaderColumn> 
					
						 </BootstrapTable>
						
						
					
					</Modal>			
					
				
			
			</div>
		
		
		)
		
	}
	
	
}

export default ModalTarifas;


// WEBPACK FOOTER //
// ./src/Components/Tarifas/ModalTarifas.jsx